import React from "react";
import { sidebarOnClicks} from "js/utilities/sdk-doc-utils";
import { Navigation, Link } from "react-router";
import StatsStore from "js/stores/stats-store";
import { Grid, Row, Col, Glyphicon} from "react-bootstrap";
import StatBox from "../elements/stat-box.jsx";
import TimerMixin from "react-timer-mixin";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import _ from "lodash";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({

  mixins: [TimerMixin],

  displayName: "stats",

  getInitialState() {
    var otherSetToDisplay = "Development"
    var stats = {
      sessions: {
        dev: {
          sdkInitialize: null,
          enrollSessionStart: null,
          authSessionStart: null,
          verifySessionStart: null,
          enrollSessionSuccess: null,
          authSessionSuccess: null,
          verifySessionSuccess: null
        },
        prod: {
          sdkInitialize: null,
          enrollSessionStart: null,
          authSessionStart: null,
          verifySessionStart: null,
          enrollSessionSuccess: null,
          authSessionSuccess: null,
          verifySessionSuccess: null
        }
      },
      dev: null,
      prod: null,
      devices: {
        dev: {android: null, ios: null, total: null},
        prod: {android: null, ios: null, total: null}
      },
      zoomSessionsStart: null,
      zoomSessionsSuccess: null,
      zoomSessionsNotCompleted: null
    }

    return ({stats: stats, recentStats: stats, otherSetToDisplay: otherSetToDisplay})
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  componentWillMount: function() {
    if (!UserHandler.loggedIn()) {
      this.context.router.push("/signin");
    }
  },

  componentDidMount: function() {
    sidebarOnClicks();
    this._fetchData();
    this.setState({interval: setInterval(this._fetchLatestData, 30 * 1000)});
  },

  componentWillUnmount: function() {
    clearInterval(this.state.interval);
  },

  swapProdDevStats: function() {
    if (this.state.otherSetToDisplay === "Development") {
      this.setState({otherSetToDisplay: "Production"})
    }
    else {
      this.setState({otherSetToDisplay: "Development"})
    }
  },

  render: function() {

    if(!UserHandler.loggedIn()) { return false; }
    var stats = {}
    var recentStats = {}

    stats.zoomSessionsStart = null
    stats.zoomSessionsSuccess = null
    stats.zoomSessionsNotCompleted = null
    if(this.state.otherSetToDisplay !== "Development") {
      stats.sessions = this.state.stats.sessions.dev
      stats.devices = this.state.stats.devices.dev
      recentStats.sessions = this.state.recentStats.sessions.dev
      recentStats.devices = this.state.recentStats.devices.dev
      if (!_.isNull(stats.sessions.enrollSessionStart)){
        stats.zoomSessionsStart = stats.sessions.enrollSessionStart + stats.sessions.authSessionStart + stats.sessions.verifySessionStart
        stats.zoomSessionsSuccess = stats.sessions.enrollSessionSuccess + stats.sessions.authSessionSuccess + stats.sessions.verifySessionSuccess
        stats.zoomSessionsNotCompleted = stats.zoomSessionsStart - stats.zoomSessionsSuccess
      }
    }
    else {
      stats.sessions = this.state.stats.sessions.prod
      stats.devices = this.state.stats.devices.prod
      recentStats.sessions = this.state.recentStats.sessions.prod
      recentStats.devices = this.state.recentStats.devices.prod
      if (!_.isNull(stats.sessions.enrollSessionStart)){
        stats.zoomSessionsStart = stats.sessions.enrollSessionStart + stats.sessions.authSessionStart + stats.sessions.verifySessionStart
        stats.zoomSessionsSuccess = stats.sessions.enrollSessionSuccess + stats.sessions.authSessionSuccess + stats.sessions.verifySessionSuccess
        stats.zoomSessionsNotCompleted = stats.zoomSessionsStart - stats.zoomSessionsSuccess
      }
    }
    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">

            <section>
              <div className="title">
                <Glyphicon glyph="stats" />
                <h2>Stats<br/></h2>
              </div>
              <span>
                <button className="btn btn-new" onClick={this.swapProdDevStats}>Show {this.state.otherSetToDisplay}</button>
              </span>
            </section>

            <div className="box-data">
              <section>
                <h4>Devices</h4>
                <Row>
                  <StatBox label="devices (that have initialized)" stat={stats.devices.total} />
                  <StatBox label="ios (clean installs)" stat={stats.devices.ios} />
                  <StatBox label="android" stat={stats.devices.android} />
                  <StatBox label="recent devices added" stat={recentStats.devices.total} />
                  <div style = {{clear:"both"}}></div>
                </Row>
              </section>
              <section>
                <h4>Zoom Sessions</h4>
                <Row>
                  <StatBox label="zoom sessions started" stat={stats.zoomSessionsStart} />
                  <StatBox label="zoom sessions succeeded" stat={stats.zoomSessionsSuccess} />
                  <StatBox label="zoom sessions not completed (cancelled, interrupted, poor lighting, etc.)" stat={stats.zoomSessionsNotCompleted} />
                  <StatBox label="last 24 hours sessions" stat={recentStats.sessions.sdkInitialize} />
                  <div style = {{clear:"both"}}></div>
                </Row>
              </section>
              <SDKSidebar menuType="account" title="Stats" />
            </div>
          </div>
        </div>
      </div>
    );
  },

  _fetchData: function() {
    var allStats = {};
    var end = Math.round(Date.now()/1000);
    end = (end - 60).toString()
    StatsStore.fetchSDKStats("0", end).then( (stats) => {
      if(stats.meta.mode == "dev") this.setState({otherSetToDisplay: "Production"})
      allStats = stats.data;
      StatsStore.fetchSDKStats("", "").then( (recentStats) => {
        this.setState({stats: allStats, recentStats: recentStats.data, latestDate: end});
      });
    });
  },

  _fetchLatestData: function() {

    var currentStats = this.state.stats
    var recentStats = this.state.recentStats
    var start = this.state.latestDate
    var end = Math.round(Date.now()/1000)
    end = (end - 60).toString()
    StatsStore.fetchSDKStats(start, end).then( (stats) => {
      this.setState({latestDate: end});

      Object.keys(stats.data.sessions.dev).forEach(function (key) {
        currentStats.sessions.dev[key] += stats.data.sessions.dev[key]
      	recentStats.sessions.dev[key] += stats.data.sessions.dev[key]
      })
      Object.keys(stats.data.sessions.prod).forEach(function (key) {
        currentStats.sessions.prod[key] += stats.data.sessions.prod[key]
      	recentStats.sessions.prod[key] += stats.data.sessions.prod[key]
      })
      Object.keys(stats.data.devices.dev).forEach(function (key) {
        currentStats.devices.dev[key] += stats.data.devices.dev[key]
      	recentStats.devices.dev[key] += stats.data.devices.dev[key]
      })
      Object.keys(stats.data.devices.prod).forEach(function (key) {
        currentStats.devices.prod[key] += stats.data.devices.prod[key]
      	recentStats.devices.prod[key] += stats.data.devices.prod[key]
      })
      this.setState({stats: currentStats, recentStats: recentStats})
    });
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/stats.jsx